import React from 'react';
import { Hero } from '../components/Hero';
import { Stats } from '../components/Stats';
import { Services } from '../components/Services';
import { Events } from '../components/Events';
import { PilotInfo } from '../components/PilotInfo';
import { Contact } from '../components/Contact';
export function HomePage() {
  return <>
      <Hero data-id="element-559" />
      <Stats data-id="element-560" />
      <Services data-id="element-561" />
      <Events data-id="element-562" />
      <PilotInfo data-id="element-563" />
      <Contact data-id="element-564" />
    </>;
}